<template>
  <div ref="page" class="special-func">
    <base-form
      ref="form"
      class="search-bar"
      v-model="toolbar.data"
      :form-items="toolbar.formItems"
      label-width="auto"
      input-trim
      inline
    ></base-form>
    <base-table-lite
      ref="table"
      url="view/getSpecialFuncData"
      :columns="columns"
      :init-search="false"
      @loaded="tableLoaded"
    ></base-table-lite>
  </div>
</template>

<script>
export default {
  name: 'special-func',
  data() {
    var currentLang = this.$root.getCurrentLang()
    // if (currentLang.toUpperCase() == 'EN') {
    //   this.$router.push({
    //     name: 'SpecialFuncV1',
    //     query: {
    //       lang: currentLang
    //     },
    //   })
    // }
    return {
      defaultSearchField: [
        'brand',
        'year',
        'series',
        'chassis',
        'model',
        'system',
        'system_type',
        'chip',
      ],
      currentLang,
      currentLangLowerCase: currentLang.toLowerCase(),
      currentProduct: '',
      currentFunc: '',
      toolbar: {
        formItems: [
          {
            label: currentLang == 'CN' ? '产品' : 'Product',
            prop: 'product',
            component: 'product-select',
            bind: {
              lang: currentLang,
              category: 'special',
            },
            on: {
              productChange: (product) => {
                this.currentProduct = product.profile
                this.$nextTick(() => {
                  this.toolbar.formItems[1].bind.profile = product.profile
                })
              },
            },
          },
          {
            label: currentLang == 'CN' ? '功能' : 'Function',
            prop: 'pack_func',
            component: 'special-func-select',
            bind: { lang: currentLang, category: 'special', profile: '' },
            on: {
              outArea: (option, areas) => {
                this.currentFunc = option.func
                this.toolbar.query.function = JSON.stringify({
                  Field: 'function',
                  ComparePattern: 'EQ',
                  Values: [option.func],
                })
                this.$nextTick(() => {
                  this.toolbar.formItems[2].bind.area = areas
                })
              },
            },
          },
          {
            label: currentLang == 'CN' ? '区域' : 'Area',
            prop: 'areaValue',
            component: 'special-area-select',
            bind: { area: [] },
            on: {
              outVersion: (option, versions) => {
                const { area, packid } = option
                const queryObj = {
                  product: this.currentProduct,
                  func: this.currentFunc,
                  area,
                  packid,
                }

                this.toolbar.query.packid = option.packid
                this.toolbar.query.area = JSON.stringify({
                  Field: 'area',
                  ComparePattern: 'EQ',
                  Values: [option.area],
                })
                this.$nextTick(() => {
                  const formItemVersion = this.toolbar.formItems[3]
                  formItemVersion.bind.queryObj = queryObj
                  formItemVersion.bind.version = versions
                })

                this.toolbar.query.packid = option.packid
                this.toolbar.query.area = JSON.stringify({
                  Field: 'area',
                  ComparePattern: 'EQ',
                  Values: [option.area],
                })
                this.$nextTick(() => {
                  this.toolbar.formItems[3].bind.version = versions
                })
              },
            },
          },
          {
            label: currentLang == 'CN' ? '版本' : 'Version',
            prop: 'version',
            component: 'version-select',
            bind: { version: [] },
            on: {
              change: (newVal) => {
                this.$nextTick(() => {
                  this.getSpecialFuncField()
                })
              },
            },
          },
        ],
        data: {},
        query: {
          packid: null,
          function: null,
          area: null,
        },
      },
      columns: [],
    }
  },
  created() {
    this.$root.autoSetCurrentLang()
  },
  computed: {
    table() {
      return this.$refs.table
    },
    form() {
      return this.$refs.form
    },
  },
  methods: {
    getSpecialFuncField() {
      var searchData = this.toolbar.data
      this.$post('view/getSpecialFuncField', {
        packid: this.toolbar.query.packid,
        version: searchData.version,
        lang: this.currentLang,
      })
        .then((resp) => {
          if (resp.data.code == 0) {
            var columns = []
            var searchFieldFormItems = []
            this.initToolbarFormItems()
            var fieldIndex = 0
            for (var item of resp.data.data) {
              //过滤不显示的列
              if (['version', 'function', 'area'].indexOf(item.field) > -1) {
                continue
              }
              var column = {
                bind: {
                  label: item[this.currentLang.toLowerCase()],
                  prop: item.field,
                },
              }
              //用对应组件渲染显示数据类型
              if (item.data_type) {
                column.default = {
                  component: item.data_type.replace('|', ''),
                  bind: { lang: this.currentLang },
                }
              }
              columns.push(column)

              //查找动态查询条件框
              if (this.defaultSearchField.indexOf(item.field) > -1) {
                searchFieldFormItems.push({
                  label: item[this.currentLang.toLowerCase()],
                  prop: item.field,
                  component: 'field-select',
                  bind: {
                    fieldIndex: fieldIndex,
                    category: 'special',
                    field: item.field,
                    lang: this.currentLang,
                    packid: this.toolbar.query.packid,
                    version: searchData.version,
                    func: this.currentFunc,
                  },
                  on: {
                    valchange: (index, val) => {
                      this.resetSearchFieldBeginBy(index, val)
                      this.tableSearch()
                    },
                  },
                })
                fieldIndex++
              }
            }
            this.columns = columns
            this.$nextTick(() => {
              for (var item of searchFieldFormItems) {
                this.toolbar.formItems.push(item)
              }
              //第一个动态查询条件框价值初始化option
              this.firstSearchFieldInit()
              this.tableSearch()
            })
          } else {
            this.$message(resp.data.msg || '获取数据失败')
          }
        })
        .catch((error) => {
          console.error(error)
          this.$message('请求发生错误=>' + error)
        })
    },
    initToolbarFormItems() {
      if (this.toolbar.formItems.length > 4) {
        //找出多余的prop
        var props = []
        for (var i = 4; i < this.toolbar.formItems.length; i++) {
          props.push(this.toolbar.formItems[i].prop)
        }
        this.toolbar.formItems.splice(4)
        //删除多余的prop
        for (var prop of props) {
          this.$delete(this.toolbar.data, prop)
        }
      }
    },
    getSearchData() {
      var searchData = Object.assign({}, this.toolbar.data, this.toolbar.query)
      for (var field of this.defaultSearchField) {
        if (searchData[field]) {
          searchData[field] = JSON.stringify({
            Field: field,
            ComparePattern: 'EQ',
            Values: [searchData[field]],
          })
        }
      }
      return searchData
    },
    tableSearch() {
      this.table.table.doLayout()
      this.$nextTick(() => {
        this.table.searchData = this.getSearchData()
        this.table.searchData.lang = this.currentLang
        this.table.query.PageIndex = 1
        this.table.refreshData()
      })
    },
    tableLoaded() {
      window.parent.postMessage(
        {
          callback: 'setIframeHeight',
          args: [this.$refs.page.scrollHeight + 50],
        },
        '*'
      )
    },
    firstSearchFieldInit() {
      this.$nextTick(() => {
        var searchData = this.getSearchData()
        for (var item of this.$refs.form.items) {
          if (item.fieldIndex == 0) {
            item.getFieldOptions(searchData)
            break
          }
        }
      })
    },
    resetSearchFieldBeginBy(index, val) {
      var searchData = this.getSearchData()
      for (var item of this.$refs.form.items) {
        if (item.fieldIndex > index) {
          item.reset()
          if (val && item.fieldIndex == index + 1) {
            item.getFieldOptions(searchData)
          }
        }
      }
    },
  },
}
</script>
<style lang="less">
.special-func {
}
</style>
